
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_47649","data-name":"Group 47649","transform":"translate(-995 -691)","fill":"none"}},[_c('rect',{attrs:{"id":"Rectangle_15921","data-name":"Rectangle 15921","width":"20","height":"20","transform":"translate(995 691)"}}),_c('g',{attrs:{"id":"Group_47648","data-name":"Group 47648","transform":"rotate(90 1005.625 698.375)","stroke":"#5858ec","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_38770","data-name":"Path 38770","d":"M2.667 0L0 2.667m0 0l2.667 2.666M0 2.667h11.333","transform":"rotate(180 508.125 350.834)"}}),_c('path',{attrs:{"id":"Path_38771","data-name":"Path 38771","d":"M14.583 7.444V5a2 2 0 00-2-2H7.25a2 2 0 00-2 2v12a2 2 0 002 2h5.333a2 2 0 002-2v-2.444","transform":"translate(995 688)"}})])])])
          )
        }
      }
    